import React from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from "react-select";
import moment from "moment";
import PhoneInput from "react-phone-number-input";
import { MiniLoader, PDFIcon } from "../reuse/SVG";
import { InputTextError } from "../reuse/FormControls";
import { DatePicker } from "antd";

const AddCamperModal = ({
    show,
    handleClose,
    handleAddNewCamperModal,
    newCampers,
    activeIndex,
    setActiveIndex,
    handleFileChange,
    miniLoader,
    handleRemove,
    handleChange,
    handleDateChange,
    handleSelectChange,
    handleCheckBoxChange,
    handleMultiSelectChange,
    handleRadioChange,
    handlePhoneChange,
    uploadHippaCompliance,
    handleRemoveMedicalDocument,
    handleSubmit,
    btnloader,
    gradeArr,
    gendersTwo,
    provinceList,
    shortsAndTshirtSizes,
    medicalList,
    allergyList,
    disabledDate,
    dateFormatNew,
    errormodal,
    setErrorModel,
    errIndexCamper
}) => {
    return (
        <Modal
            show={show}
            size="lg"
            dialogClassName="remove_header_line"
            centered
        >
            <Modal.Header>
                <Modal.Title>Add Participants</Modal.Title>
                <span className="modal_close" onClick={handleClose}>
                    <i className="icon-cross" />
                </span>
            </Modal.Header>
            <Modal.Body>
                {/* Error Modal */}
                <Modal
                    className="cm_error_modal"
                    show={errormodal}
                    animation={false}
                    centered
                >
                    <Modal.Body>
                        <div className="p-5">
                            <h3 className="text-center mb-4">Error</h3>
                            Please Fill All Required Fields for Participant {errIndexCamper + 1}
                            <button
                                onClick={() => setErrorModel(false)}
                                className="btn btn-primary w-100 mt-2"
                            >
                                Ok
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>

                <div id="cm_scrollInTo">
                    <span
                        className="btn color_primary p-0"
                        onClick={handleAddNewCamperModal}
                    >
                        <i className="icon-plus" /> Add more participants
                    </span>
                </div>

                {/* Tabs for Participants */}
                <div className="mt-3 mb-3 bottom_border">
                    {newCampers.map((item, i) => (
                        <span
                            key={i}
                            className={`me-2 mb-2 btn btn-outline-dark rounded-0 ${activeIndex === i ? "cm_active" : ""
                                }`}
                            onClick={() => setActiveIndex(i)}
                        >
                            Participant {i + 1}
                        </span>
                    ))}
                </div>

                {/* Camper Form(s) */}
                {newCampers.map((item, i) => (
                    <div
                        key={i}
                        style={{ display: activeIndex === i ? "block" : "none" }}
                    >
                        {/* Extract this block into CamperForm.jsx later if needed */}
                        <div className="spaceform">
                            {/* Profile Upload */}
                            <div className="profile_upload">
                                {item.profileImage ? <img src={item.profileImage} /> : ""}
                                <input
                                    onChange={(e) => handleFileChange(e, i)}
                                    value=""
                                    type="file"
                                    accept="image/x-png,image/gif,image/jpeg"
                                />
                                {miniLoader[i] ? (
                                    <div className="mini_loader">
                                        <MiniLoader />
                                    </div>
                                ) : (
                                    <i className="icon-camera-plus" />
                                )}
                            </div>

                            <div className='row'>

                                <div className="col-lg-5 d-flex align-items-center mb-4">
                                    <label style={{ minWidth: '110px' }}>Participant :</label>
                                    <input
                                        disabled
                                        value={item.groupcode}
                                        type="text"
                                        className='form-control'
                                        placeholder="Group Code" />
                                </div>

                                <div className="col-lg-7 d-flex align-items-end justify-content-end mb-4">
                                    {newCampers.length > 1 ? <span onClick={() => handleRemove(i)} className='btn btn-dark'>Delete</span> : ''}
                                </div>

                                <div className='col-md-12'></div>


                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>First Name</label>
                                        <input
                                            value={item.firstName}
                                            onChange={e => handleChange(e, i)}
                                            type='text'
                                            name="firstName"
                                            className={`form-control ${item.firstNameErr ? 'is-invalid' : ''}`} />

                                        {item.firstNameErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{item.firstNameErr}</Tooltip>}><i className="input_info" /></OverlayTrigger> : ''}
                                    </div>
                                </div>




                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Last Name</label>
                                        <input
                                            value={item.lastName}
                                            onChange={e => handleChange(e, i)}
                                            type='text'
                                            name="lastName"
                                            className={`form-control ${item.lastNameErr ? 'is-invalid' : ''}`} />

                                        {item.lastNameErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{item.lastNameErr}</Tooltip>}><i className="input_info" /></OverlayTrigger> : ''}
                                    </div>
                                </div>


                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Date of Birth</label>
                                        <DatePicker
                                            disabledDate={disabledDate}
                                            value={item.dob ? moment.utc(parseInt(item.dob)) : ''}
                                            className={`form-control ${item.dobErr ? 'is-invalid' : ''}`}
                                            placeholder="Date of Birth"
                                            format={dateFormatNew}
                                            onChange={e => handleDateChange(e, 'dob', i)} />

                                        {item.dobErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{item.dobErr}</Tooltip>}><i className="input_info" /></OverlayTrigger> : ''}
                                    </div>
                                </div>


                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Select Current Grade As of Today</label>
                                        <Select
                                            placeholder="Select shorts size"
                                            onChange={e => handleSelectChange(e, 'currentGrade', i)}
                                            classNamePrefix="cm_select"
                                            value={item.currentGrade ? { label: item.currentGrade, value: item.currentGrade } : ''}
                                            options={gradeArr.map(i => ({ value: i, label: i }))}
                                            className={`form-control ${item.currentGradeErr ? 'is-invalid' : ''}`}
                                        />

                                        {item.currentGradeErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{item.currentGradeErr}</Tooltip>}><i className="input_info" /></OverlayTrigger> : ''}
                                    </div>
                                </div>


                                <div className="col-md-12 d-flex cm_gendr pro_wrapper">
                                    <label>Sex</label>
                                    <ul className="d-flex">
                                        {
                                            gendersTwo.map((itm, ind) => (
                                                <li className="me-2 check_box_wrapper" key={ind}>
                                                    <input
                                                        type="checkbox"
                                                        name="gender"
                                                        checked={item.gender === itm.value ? 'checked' : ''}
                                                        value={item.gender}
                                                        onChange={e => handleCheckBoxChange(e, i, itm.value)}
                                                    />
                                                    <span className="check_box"><span /> {itm.label}</span>
                                                </li>
                                            ))
                                        }
                                    </ul>

                                    <div>{item.genderErr ? <span className='cm_error'>{item.genderErr}</span> : ''}</div>
                                </div>


                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Street Address</label>
                                        <input
                                            value={item.address}
                                            onChange={e => handleChange(e, i)}
                                            type='text'
                                            name="address"
                                            className={`form-control ${item.addressErr ? 'is-invalid' : ''}`} />

                                        {item.addressErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{item.addressErr}</Tooltip>}><i className="input_info" /></OverlayTrigger> : ''}
                                    </div>
                                </div>


                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Apt./Suite/Unit [optional]</label>
                                        <input
                                            value={item.apartment}
                                            onChange={e => handleChange(e, i)}
                                            type='text'
                                            name="apartment"
                                            className={`form-control ${item.apartmentErr ? 'is-invalid' : ''}`} />

                                        {item.apartmentErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{item.apartmentErr}</Tooltip>}><i className="input_info" /></OverlayTrigger> : ''}
                                    </div>
                                </div>


                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>City</label>
                                        <input
                                            value={item.city}
                                            onChange={e => handleChange(e, i)}
                                            type='text'
                                            name="city"
                                            className={`form-control ${item.cityErr ? 'is-invalid' : ''}`} />

                                        {item.cityErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{item.cityErr}</Tooltip>}><i className="input_info" /></OverlayTrigger> : ''}
                                    </div>
                                </div>


                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Zip Code</label>
                                        <input
                                            type="number"
                                            value={item.zipCode}
                                            onChange={e => handleChange(e, i)}
                                            name="zipCode"
                                            error={item.zipCodeErr}
                                            errorDisplayType={"text"}
                                            className={`form-control ${item.zipCodeErr ? 'is-invalid' : ''}`} />

                                        {item.zipCodeErr && <InputTextError error={item.zipCodeErr} />}
                                    </div>
                                </div>


                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <label>State/Province</label>

                                        <select
                                            value={item.state}
                                            onChange={e => handleChange(e, i)}
                                            name="state"
                                            className={`form-control ${item.stateErr ? 'is-invalid' : ''}`} >

                                            <option value="">Select State/Province</option>
                                            {provinceList.map(item => (
                                                <option key={item.value} value={item.value}>
                                                    {item.value} - {item.label}
                                                </option>
                                            ))}
                                        </select>

                                        {item.stateErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{item.stateErr}</Tooltip>}><i className="input_info" /></OverlayTrigger> : ''}
                                    </div>
                                </div>


                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>T-shirt Size</label>
                                        <Select
                                            placeholder="Select t-shirt size"
                                            onChange={e => handleSelectChange(e, 'tshirtSize', i)}
                                            classNamePrefix="cm_select"
                                            className={`form-control ${item.tshirtSizeErr ? 'is-invalid' : ''}`}
                                            value={item.tshirtSize ? { label: item.tshirtSize, value: item.tshirtSize } : ''}
                                            options={shortsAndTshirtSizes.map(i => ({ value: i, label: i }))} />

                                        {item.tshirtSizeErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{item.tshirtSizeErr}</Tooltip>}><i className="input_info" /></OverlayTrigger> : ''}
                                    </div>
                                </div>


                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Shorts Size</label>
                                        <Select
                                            placeholder="Select shorts size"
                                            onChange={e => handleSelectChange(e, 'shortsSize', i)}
                                            classNamePrefix="cm_select"
                                            className={`form-control ${item.shortsSizeErr ? 'is-invalid' : ''}`}
                                            value={item.shortsSize ? { label: item.shortsSize, value: item.shortsSize } : ''}
                                            options={shortsAndTshirtSizes.map(i => ({ value: i, label: i }))} />

                                        {item.shortsSizeErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{item.shortsSizeErr}</Tooltip>}><i className="input_info" /></OverlayTrigger> : ''}
                                    </div>
                                </div>


                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Medical</label>
                                        <Select
                                            isMulti
                                            placeholder="Select medical"
                                            onChange={e => handleMultiSelectChange(e, 'medical', i)}
                                            classNamePrefix="cm_select"
                                            value={item.medical ? item.medical.map(i => ({ value: i, label: i })) : []}
                                            options={medicalList.map(i => ({ value: i, label: i }))}
                                            className={`form-control ${item.medicalErr ? 'is-invalid' : ''}`}
                                        />

                                        {item.medicalErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{item.medicalErr}</Tooltip>}><i className="input_info" /></OverlayTrigger> : ''}

                                    </div>
                                </div>



                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Allergy</label>
                                        <Select
                                            isMulti
                                            placeholder="Select allergy"
                                            onChange={e => handleMultiSelectChange(e, 'allergy', i)}
                                            classNamePrefix="cm_select"
                                            value={item.allergy ? item.allergy.map(i => ({ value: i, label: i })) : []}
                                            options={allergyList.map(i => ({ value: i, label: i }))}
                                            className={`form-control ${item.allergyErr ? 'is-invalid' : ''}`}
                                        />

                                        {item.allergyErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{item.allergyErr}</Tooltip>}><i className="input_info" /></OverlayTrigger> : ''}
                                    </div>
                                </div>


                                <div className="col-md-12 d-flex cm_gendr pro_wrapper">
                                    <label>Allergy is deadly</label>
                                    <ul className="d-flex">
                                        <li className="me-2 check_box_wrapper">
                                            <input
                                                onChange={e => handleRadioChange(e, i)}
                                                type="radio"
                                                value={1}
                                                checked={item.allergyDeadly === 1}
                                                name="allergyDeadly" />
                                            <span className="check_box"><span /> Yes</span>
                                        </li>
                                        <li className="me-2 check_box_wrapper">
                                            <input
                                                onChange={e => handleRadioChange(e, i)}
                                                type="radio"
                                                value={2}
                                                checked={item.allergyDeadly === 2}
                                                name="allergyDeadly" />
                                            <span className="check_box"><span /> No</span>
                                        </li>
                                    </ul>
                                </div>


                                <div className='col-md-12'>
                                    <h5>Insurance Information:</h5>
                                </div>


                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Medical Insurance Company</label>
                                        <input
                                            value={item.medicalInsuranceCompany}
                                            onChange={e => handleChange(e, i)}
                                            type='text'
                                            name="medicalInsuranceCompany"
                                            className='form-control' />
                                    </div>
                                </div>


                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Policy Number</label>
                                        <input
                                            value={item.policyNumber}
                                            onChange={e => handleChange(e, i)}
                                            type='text'
                                            name="policyNumber"
                                            className='form-control' />
                                    </div>
                                </div>


                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Group #</label>
                                        <input
                                            value={item.group}
                                            onChange={e => handleChange(e, i)}
                                            type='text'
                                            name="group"
                                            className='form-control' />
                                    </div>
                                </div>


                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Primary Physician</label>
                                        <input
                                            value={item.primaryPhysician}
                                            onChange={e => handleChange(e, i)}
                                            type='text'
                                            name="primaryPhysician"
                                            className='form-control' />
                                    </div>
                                </div>


                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Physician Address</label>
                                        <input
                                            value={item.physicianAddress}
                                            onChange={e => handleChange(e, i)}
                                            type='text'
                                            name="physicianAddress"
                                            className='form-control' />
                                    </div>
                                </div>


                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Physician Phone #</label>
                                        <PhoneInput
                                            country="US"
                                            placeholder="Phone number"
                                            className={`form-control`}
                                            onChange={e => handlePhoneChange(e, 'physicianPhone', i)}
                                            maxLength={16}
                                            value={item.physicianPhone}
                                            name="phone" />
                                    </div>
                                </div>


                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <label>Please list any medications taken(please include dosage & timing) or any other special assistance necessary to attend a program. (Leave blank if none)</label>
                                        <textarea
                                            value={item.medicationsTaken}
                                            onChange={e => handleChange(e, i)}
                                            name="medicationsTaken"
                                            className='form-control' />
                                    </div>
                                </div>


                                <div className="col-md-12 form-group">
                                    <label>Parent Permission for EMERGENCY MEDICATIONS: (rescue inhaler, glucagon, epinephrine)</label>
                                </div>


                                <div className="col-md-12 cm_gendr pro_wrapper">
                                    <label>Participant has permission to carry his/her own emergency medication, or inhaler:</label>
                                    <ul className="d-flex">
                                        <li className="me-2 check_box_wrapper">
                                            <input
                                                onChange={e => handleRadioChange(e, i)}
                                                type="radio"
                                                value={1}
                                                checked={item.permissionEmergencyMedication === 1}
                                                name="permissionEmergencyMedication" />
                                            <span className="check_box"><span /> Yes</span>
                                        </li>
                                        <li className="me-2 check_box_wrapper">
                                            <input
                                                onChange={e => handleRadioChange(e, i)}
                                                type="radio"
                                                value={2}
                                                checked={item.permissionEmergencyMedication === 2}
                                                name="permissionEmergencyMedication" />
                                            <span className="check_box"><span /> No</span>
                                        </li>
                                    </ul>
                                </div>



                                <div className="col-md-12 cm_gendr pro_wrapper">
                                    <label>May the participant receive over-the counter medication:</label>
                                    <ul className="d-flex">
                                        <li className="me-2 check_box_wrapper">
                                            <input
                                                onChange={e => handleRadioChange(e, i)}
                                                type="radio"
                                                value={1}
                                                checked={item.participantReceiveCounterMedication === 1}
                                                name="participantReceiveCounterMedication" />
                                            <span className="check_box"><span /> Yes</span>
                                        </li>
                                        <li className="me-2 check_box_wrapper">
                                            <input
                                                onChange={e => handleRadioChange(e, i)}
                                                type="radio"
                                                value={2}
                                                checked={item.participantReceiveCounterMedication === 2}
                                                name="participantReceiveCounterMedication" />
                                            <span className="check_box"><span /> No</span>
                                        </li>
                                    </ul>
                                </div>



                                <div className="col-md-12 cm_gendr pro_wrapper">
                                    <label>Will the participant be bringing their own medication, or an inhaler to a program: </label>
                                    <ul className="d-flex">
                                        <li className="me-2 check_box_wrapper">
                                            <input
                                                onChange={e => handleRadioChange(e, i)}
                                                type="radio"
                                                value={1}
                                                checked={item.participantBringingOwnMedication === 1}
                                                name="participantBringingOwnMedication" />
                                            <span className="check_box"><span /> Yes</span>
                                        </li>
                                        <li className="me-2 check_box_wrapper">
                                            <input
                                                onChange={e => handleRadioChange(e, i)}
                                                type="radio"
                                                value={2}
                                                checked={item.participantBringingOwnMedication === 2}
                                                name="participantBringingOwnMedication" />
                                            <span className="check_box"><span /> No</span>
                                        </li>
                                    </ul>
                                </div>


                                <div className="col-md-12 form-group">
                                    <label>If the Participant is bringing medication please note:</label>
                                    <label>All Medication must be sent in the original container and must state the current instructions for dispensing.  All medications must be turned in when attendee is dropped off, if permission is not granted above for them to carry it.</label>
                                </div>


                                <div className="col-md-12 cm_gendr pro_wrapper">
                                    <label>Service Provider Staff may document participant with digital and film photography and/or video.</label>
                                    <ul className="d-flex">
                                        <li className="me-2 check_box_wrapper">
                                            <input
                                                onChange={e => handleRadioChange(e, i)}
                                                type="radio"
                                                value={1}
                                                checked={item.allowDocumentCamper === 1}
                                                name="allowDocumentCamper" />
                                            <span className="check_box"><span /> Yes</span>
                                        </li>
                                        <li className="me-2 check_box_wrapper">
                                            <input
                                                onChange={e => handleRadioChange(e, i)}
                                                type="radio"
                                                value={2}
                                                checked={item.allowDocumentCamper === 2}
                                                name="allowDocumentCamper" />
                                            <span className="check_box"><span /> No</span>
                                        </li>
                                    </ul>
                                </div>


                                <div className="col-md-12 form-group">
                                    <label>Please attach any accompanying documents that you feel are necessary for attendance (Additional Medical document etc).</label>
                                    <div className={`attach_file_btn  btn_anim ${item.medicalDocumentLoader ? 'show_anim' : ''}`}>
                                        Attach PDF
                                        <input
                                            type="file"
                                            value=""
                                            accept="application/pdf"
                                            onChange={e => uploadHippaCompliance(e, 'medicalDocument', i, 'medicalDocumentLoader')} />
                                    </div>

                                    {
                                        item.medicalDocument ? <div className="cm_pdf_icon"><PDFIcon /><i className="icon-cross" onClick={() => handleRemoveMedicalDocument('medicalDocument', i)} /> <p>{item.medicalDocument ? item.medicalDocument.slice(item.medicalDocument.lastIndexOf('_') + 1) : ''}</p></div> : ''
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                ))}

                {/* Save Button */}
                <div className="text-center">
                    <button
                        disabled={btnloader}
                        onClick={handleSubmit}
                        className={`btn btn-primary rounded-0 ${btnloader ? "btnLoader" : ""
                            }`}
                    >
                        Save
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AddCamperModal;